import InnerBanner from "../Components/InnerBanner/InnerBanner";
import MultiContent from "../Components/MultiContent/MultiContent";

function Workforce() {
    return (
        <>
            <InnerBanner
                img_url='corporateBanner.webp'
                heading={['Corporate Services That ', <br/>, 'Underpin Your Goals']}
                isDescription
                description="
                            Working with corporate clients is what we do, and we are here to help you maximise the
                            DevOps expertise that your business can offer. We are here to help you overcome any
                            challenges you might face by helping you to get the most from your workforce.
                            "
            />
            <MultiContent
                left_img
                tag="Corporate Services"
                topHeading
                heading="Workforce Training"
                description={[
                    "Elevate your team's expertise with Skill Bridge's tailored Workforce Training. Discover our comprehensive courses designed to upskill your workforce in DevOps and Cloud engineering. Whether you're seeking to enhance your team's skills or align training with specific organizational needs, Skill Bridge is your partner in professional development. Unlock your team's potential today.",
                ]}
                img_url='corporate1.webp'
            />
            <MultiContent
                right_img
                class="coloured"
                topHeading
                heading="Consulting Service"
                descClass='med'
                description={[
                    "Skill Bridge's seasoned professionals and graduates offer expert consulting services, including cloud automation and migration. Benefit from their knowledge and experience to streamline your operations and achieve greater efficiency. Explore how our consulting services can elevate your organization and drive success. Get in touch with Skill Bridge for tailored solutions to your unique challenges."
                ]}
                img_url='corporate2.webp'
                accordion={[
                    {
                        'head': 'Employee Training and Upskilling',
                        'content': 'At Skill Bridge we recognise the importance of investing in your workforce\'s skills and\n' +
                            'knowledge. Our corporate services offer customised training programs to upskill your\n' +
                            'existing employees in DevOps methodologies, tools, and best practices. We work closely\n' +
                            'with you to design training that aligns with your company\'s specific needs and goals,\n' +
                            'ensuring that your team is equipped for success in a rapidly evolving industry.'
                    },
                    {
                        'head': 'Team Building and Collaboration',
                        'content': 'Effective DevOps hinges on collaboration. Our workshops and team-building exercises\n' +
                            'foster a culture of cooperation between development and operations teams. We emphasise\n' +
                            'communication and collaboration, helping your teams work harmoniously to drive innovation.'
                    },
                    {
                        'head': 'Tooling and Technology Implementation',
                        'content': 'Selecting the right DevOps tools and technologies is critical. Skill Bridge offers expert\n' +
                            'guidance on tool selection and hands-on training, ensuring that your technology choices\n' +
                            'align with your business objectives.'
                    },
                ]}
            />
            <MultiContent
                left_img
                img_url='corporate3.webp'
                description={[
                    'Skill Bridge is dedicated to helping your organisation thrive in the DevOps landscape.\n' +
                    'Contact us today to explore how our corporate services can elevate your business, drive\n' +
                    'innovation, and position your company for success in the ever-evolving tech industry. Your\n' +
                    'journey to DevOps excellence begins here.'
                ]}
                accordion={[
                    {
                        'head': 'Process Optimisation',
                        'content': 'Identifying and addressing process inefficiencies is essential. We assess your workflows,\n' +
                            'pinpoint bottlenecks, and offer consultations to streamline processes. Our expertise in CI/CD\n' +
                            'pipelines enables you to achieve efficient software delivery.'
                    },
                    {
                        'head': 'Consultation and Advisory Services',
                        'content': 'Our experts provide advice and consulting services to address challenges on your DevOps\n' +
                            'journey. We collaborate with you to create a customised DevOps strategy and roadmap,\n' +
                            'ensuring successful transformation.'
                    },
                    {
                        'head': 'Troubleshooting and Incident Response',
                        'content': 'Prepare for incidents with our incident management training. We equip your teams to\n' +
                            'minimise downtime and improve incident resolution times through simulations and real-world\n' +
                            'scenarios.'
                    },
                    {
                        'head': 'DevOps Best Practices',
                        'content': 'Staying current with industry best practices is vital. Skill Bridge offers training on version\n' +
                            'control, automated testing, infrastructure as code (IaC), and more. We guide your teams on\n' +
                            'effective application within your organisation.'
                    },
                    {
                        'head': 'Security Integration',
                        'content': 'Security is a top priority. Our training in DevSecOps principles enables seamless security\n' +
                            'integration into your DevOps pipeline, including security scanning and vulnerability\n' +
                            'assessments.'
                    }
                ]}
            />
        </>
    )
}

export default Workforce